﻿export enum CustomerType {
    Undefined = 0,
    Billing = 1,
    Shipping = 2
}